import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateStreamingSettingsMutation } from "../graphql/mutations";
import type {
  UpdateStreamingSettingsMutationType,
  UpdateStreamingSettingsMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateStreamingSettingsMutation = (
  options?: MutationHookOptions<
    UpdateStreamingSettingsMutationType,
    UpdateStreamingSettingsMutationVariablesType
  >
) => {
  return useMutation<
    UpdateStreamingSettingsMutationType,
    UpdateStreamingSettingsMutationVariablesType
  >(UpdateStreamingSettingsMutation, options);
};
